/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';

export interface DeleteServiceProviderOrganizations$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
}

export function deleteServiceProviderOrganizations(http: HttpClient, rootUrl: string, params: DeleteServiceProviderOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteServiceProviderOrganizations.PATH, 'delete');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteServiceProviderOrganizations.PATH = '/service-provider/organizations/{organizationKey}';
